import { render, staticRenderFns } from "./FormPeriodoVigencia.vue?vue&type=template&id=f711670c"
import script from "./FormPeriodoVigencia.vue?vue&type=script&lang=js"
export * from "./FormPeriodoVigencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports